import * as React from 'react'
import {
  AppBar,
  Box,
  Button,
  Divider,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
} from '@mui/material'

// import axios from 'axios'

import ClientsService from '../service/clients'

const style = {
  bgcolor: 'background.paper',
  boxShadow: 24,
  left: '50%',
  p: 4,
  position: 'absolute',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1336,
}

const thStyles = {
  '&::after': {
    borderLeft: '2px #e0e0e0 solid',
    content: '""',
    height: '30%',
    marginBottom: 'auto',
    marginTop: 'auto',
    position: 'absolute',
    right: 0,
    top: '35%',
  },
  position: 'relative',
}

type HistoryData = {
  id: number
  date: string
  user: number
  value: number
  change: number
}

type AuditHistoryData = {
  jobId: number
  clientId: number
  jobStatus: string
  countEligible: number
  countProcessed: number
  countSuccess: number
  countError: number
  startTimestamp: string
  endTimestamp: string
}

type Page = {
  pageNumber: number
  pageSize: number
  totalElements: number
  totalPages: number
  numberOfElements: number
}
type Props = {
  trClientId: number
  clientAuditHistory: string
}

const NOT_AVAILABLE = 'Not Available'

export default function ClientAuditHistory({
  trClientId,
  clientAuditHistory,
}: Props) {
  const [open, setOpen] = React.useState(false)
  const [isPageLoading, setIsPageLoading] = React.useState(false)

  const handleClose = () => setOpen(false)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [pageData, setPageData] = React.useState<Page>({
    numberOfElements: 0,
    pageNumber: 0,
    pageSize: 5,
    totalElements: 0,
    totalPages: 0,
  })
  const [pageHistoryData, setPageHistoryData] = React.useState<
    AuditHistoryData[] | HistoryData[]
  >([])

  const handleOpen = () => {
    setOpen(true)
    getAuditHistory(rowsPerPage, 0)
  }
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    getAuditHistory(rowsPerPage, newPage)
  }
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    getAuditHistory(parseInt(event.target.value, 10), 0)
  }
  async function getAuditHistory(pageSize: number, pageNumber: number) {
    setIsPageLoading(true)
    const request = clientAuditHistory === 'TrackerEnableHistory' 
      ? ClientsService.getClientEditHistory(trClientId, pageSize, pageNumber)
      : ClientsService.getClientMigrationStatus(trClientId, pageSize, pageNumber)
    request.then(function (result) {
      setPageHistoryData([])
      setPageHistoryData(result.content)
      setIsPageLoading(false)
      setPageData({
        numberOfElements: result.numberOfElements,
        pageNumber: result.pageable.pageNumber,
        pageSize: result.pageable.pageSize,
        totalElements: result.totalElements,
        totalPages: result.totalPages,
      })
    })
  }

  return (
    <div>
      {clientAuditHistory === 'TrackerEnableHistory' ? (
        <Button
          onClick={handleOpen}
          sx={{ fontWeight: 400, padding: 0, textTransform: 'none' }}
        >
          View edit history
        </Button>
      ) : (
        <Button
          color="primary"
          onClick={handleOpen}
          sx={{ textTransform: 'none' }}
          variant="outlined"
        >
          View data migration status
        </Button>
      )}

      <Modal
        aria-describedby="modal-modal-description"
        aria-labelledby="modal-modal-title"
        disableScrollLock={false}
        onClose={handleClose}
        open={open}
      >
        <Box sx={style}>
          <AppBar component="nav" sx={{ background: '#02122c' }}>
            <Toolbar>
              <b>{clientAuditHistory === 'TrackerEnableHistory' ? 'Edit History' : 'Data Migration Status'}</b>
            </Toolbar>
          </AppBar>
          <Box component="main" sx={{ p: 7 }}>
            {clientAuditHistory === 'TrackerEnableHistory' ? (
              <TableContainer sx={{ maxHeight: 250 }}>
                <Table aria-label="simple table" sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" sx={thStyles} width="214px">
                        Date
                      </TableCell>
                      <TableCell align="left" sx={thStyles}>
                        User
                      </TableCell>
                      <TableCell align="left" sx={thStyles} width="214px">
                        Value
                      </TableCell>
                      <TableCell align="left">Change</TableCell>
                    </TableRow>
                  </TableHead>

                  {pageHistoryData.length > 0 || isPageLoading ? (
                    <TableBody>
                      {pageHistoryData.map(auditRow => {
                        const row = auditRow as HistoryData
                        return (
                          <TableRow
                            key={row.date}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 },
                            }}
                          >
                            <TableCell align="left" width="214px">
                              {row.date}
                            </TableCell>
                            <TableCell align="left">{row.user}</TableCell>
                            <TableCell align="left" width="214px">
                              {row.value}
                            </TableCell>
                            <TableCell align="left">{row.change}</TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  ) : (
                    NOT_AVAILABLE
                  )}
                </Table>
              </TableContainer>
            ) : (
              <TableContainer sx={{ maxHeight: 250 }}>
                <Table aria-label="simple table" sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Migration Job Id</TableCell>
                      <TableCell align="left">HPIDs Eligibile</TableCell>
                      <TableCell align="left">HPIDs Processed</TableCell>
                      <TableCell align="left">HPIDs Migrated</TableCell>
                      <TableCell align="left">HPIDs Failed</TableCell>
                      <TableCell align="left">Migration Status</TableCell>
                      <TableCell align="left">Migration Start</TableCell>
                      <TableCell align="left">Migration End</TableCell>
                    </TableRow>
                  </TableHead>

                  {pageHistoryData.length > 0 || isPageLoading ? (
                    <TableBody>
                      {pageHistoryData.map(auditRow => {
                        const row = auditRow as AuditHistoryData
                        return (
                          <TableRow
                            key={row.jobId}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 },
                            }}
                          >
                            <TableCell align="left">
                              {row.jobId || NOT_AVAILABLE}
                            </TableCell>
                            <TableCell align="left">
                              {row.countEligible || NOT_AVAILABLE}
                            </TableCell>
                            <TableCell align="left">
                              {row.countProcessed || NOT_AVAILABLE}
                            </TableCell>
                            <TableCell align="left">
                              {row.countSuccess || NOT_AVAILABLE}
                            </TableCell>
                            <TableCell align="left">{row.countError || NOT_AVAILABLE}</TableCell>
                            <TableCell align="left">{row.jobStatus || NOT_AVAILABLE}</TableCell>
                            <TableCell align="left">
                              {row.startTimestamp || NOT_AVAILABLE}
                            </TableCell>
                            <TableCell align="left">
                              {row.endTimestamp || NOT_AVAILABLE}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  ) : (
                    NOT_AVAILABLE
                  )}
                </Table>
              </TableContainer>
            )}
            <Divider />

            <TablePagination
              component="div"
              count={pageData.totalElements}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={pageData.pageNumber}
              rowsPerPage={rowsPerPage}
            />
          </Box>
          <Box></Box>
          <Box>
            <Button
              onClick={() => setOpen(false)}
              sx={{ bottom: 24, position: 'absolute', right: 24 }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  )
}
